import React, {useState, useEffect} from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  createTheme,
  Slide,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import Note from '../../assets/images/note.png';
import SearchAdviser from '../../assets/images/searchAdviser.gif';
import CloseButton from '../../assets/icons/close-circle.svg';
import {ThemeProvider} from 'react-jss';
import {useHistory} from 'react-router-dom';

const useStyles = makeStyles({
  title: {
    fontFamily: 'IRANSansX',
    color: '#1D2129',
    fontSize: 15,
    fontWeight: 600,
    marginTop: '10px',
    textAlign: 'center',
  },
  div: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },

  text: {
    fontFamily: 'IRANSansX',
    color: '#4E5969',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: 'large',
    fontWeight: 400,
    textAlign: 'center',
    width: '270px',
    marginTop: '0.5px',
  },
  button: {
    backgroundColor: '#F2F3F5',
    color: '#1D2129',
    borderRadius: '12px',
    // margin: '0px 5px',
    fontFamily: 'IRANSansX',
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: 'large',
    width: '130px',
    height: '48px',
    '&:hover': {
      backgroundColor: '#F2F3F5',
    },
  },
});

const theme = createTheme();

const LoadingDots = () => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev?.length < 3 ? prev + '.' : ''));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <p
      style={{
        direction: 'rtl',
        width: '10px',
        marginTop: '20px',
        marginRight: '5px',
      }}
    >
      {dots}
    </p>
  );
};

export default function BestAdviserModal({
  openAccessModal,
  setOpenAccessModal,
}) {
  const [Loading, setLoading] = useState(false);
  const [adviserType, setadviserType] = useState('');
  const classes = useStyles();
  const history = useHistory();
  const handleHardReload = () => {
    setOpenAccessModal(false);
  };

  const handleNavigation = (link, name) => {
    const ids = link?.map((item) => {
      return item.replace(/^.*advisers\/([a-z0-9-]+)\/booking.*$/, '$1');
    });

    setLoading(true);
    setadviserType(name);
    setTimeout(() => {
      setLoading(false);
      setOpenAccessModal(false);
      setadviserType('');
      // history.push(link);
      // window.location.href = link;
      window.location.href = link[Math.floor(Math.random() * link?.length)];
    }, 3000);
  };

  const adviserInfo = [
    {
      name: 'متخصص زنان',
      link: [
        `https://web.pezeshket.com/app/advisers/a20aa6ca-c4e3-404b-9819-c850c119ff86/booking`,
        `https://web.pezeshket.com/app/advisers/348c0c73-738e-4540-b138-3e23e518194e/booking`,
        `https://web.pezeshket.com/app/advisers/010ece35-4384-4bf2-8891-cf751dd79ea7/booking`,
        `https://web.pezeshket.com/app/advisers/1d67eb0e-3ad5-48ee-b7c7-ea80d839ce7f/booking`,
        `https://web.pezeshket.com/app/advisers/3a1ddbe0-474e-485e-b6b5-661397cfb846/booking`,
      ],
      skill: 9,
    },
    {
      name: 'روانشناس',
      link: [
        `https://web.pezeshket.com/app/advisers/2d4c23a1-f567-4183-b82c-23df901c3fa9/booking`,
        `https://web.pezeshket.com/app/advisers/02607b56-8134-4b58-8aea-5b0246b78160/booking`,
        `https://web.pezeshket.com/app/advisers/402ca56d-0e87-40b9-b517-428b05c6ee01/booking`,
        `https://web.pezeshket.com/app/advisers/60d7cadf-db1d-4ee3-8c5c-a78c8f86a53e/booking`,
        `https://web.pezeshket.com/app/advisers/8d931bc9-b6ea-4e81-8121-8349323155e3/booking`,
      ],
      skill: 10,
    },
    {
      name: 'روانپزشک',
      link: [
        `https://web.pezeshket.com/app/advisers/4b69e599-5321-44c7-a57f-50c4d5f91adf/booking`,
        `https://web.pezeshket.com/app/advisers/d645ccc2-d67b-4872-b0bc-f9b2016ed262/booking`,
        `https://web.pezeshket.com/app/advisers/94920e63-1d8e-4a16-ba5c-ecd060eb23e2/booking`,
        `https://web.pezeshket.com/app/advisers/66a4446f-6091-470d-a1ae-d3932bf9c89c/booking`,
        `https://web.pezeshket.com/app/advisers/1e5e499b-cc41-4842-9c13-88438adc3beb/booking`,
      ],
      skill: 11,
    },
    {
      name: 'پزشک عمومی',
      link: [
        `https://web.pezeshket.com/app/advisers/85094376-1554-432e-b81d-fc38a485611a/booking`,
        `https://web.pezeshket.com/app/advisers/96b936c2-325e-484a-a57e-f79569bc1bc6/booking`,
        `https://web.pezeshket.com/app/advisers/5d253ee8-0fa5-4e67-a813-9b55371f2303/booking`,
        `https://web.pezeshket.com/app/advisers/1fc6d080-5256-42c9-b438-ea9e0ba30af5/booking`,
        `https://web.pezeshket.com/app/advisers/15889338-d1b0-4786-9202-2f42ca19cccf/booking`,
      ],
      skill: 34,
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Dialog
          open={openAccessModal}
          TransitionComponent={Slide}
          TransitionProps={{
            direction: 'up',
            timeout: 800,
          }}
          PaperProps={{
            style: {
              borderRadius: '24px',
              width: 323,
              height: 388,
              textAlign: 'center',
            },
          }}
        >
          <DialogContent>
            <div style={{position: 'absolute', top: 14, left: 14}}>
              <Button
                style={{
                  minWidth: '20px',
                  padding: 0,
                  margin: 0,
                }}
                onClick={handleHardReload}
              >
                <img
                  src={CloseButton}
                  style={{
                    width: '20px',
                    height: '20px',
                    display: 'block',
                  }}
                  alt="close"
                />
              </Button>
            </div>
            {!Loading ? (
              <div className={classes.div}>
                <img src={Note} style={{width: '162px', height: '137px'}} />
                <h2 className={classes.title}>
                  نمیدونی کدوم مشاور بهتر و قابل اعتمادتره؟
                </h2>
                <p className={classes.text}>
                  بهترین ها رو بهت معرفی میکنیم،
                  <br />
                  به کدوم حوزه نیازی داری؟
                </p>
                <Grid
                  container
                  spacing={1}
                  style={{
                    margin: '27px',
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'start',
                    height: '106px',
                  }}
                >
                  {adviserInfo?.map((item) => (
                    <Grid
                      style={{textAlign: 'center'}}
                      item
                      xs={6}
                      key={item.link}
                    >
                      <Button
                        fullWidth
                        className={classes.button}
                        onClick={() => handleNavigation(item.link, item.name)}
                      >
                        {item.name}
                      </Button>
                    </Grid>
                  ))}
                </Grid>
              </div>
            ) : (
              <div style={{textAlign: 'center'}}>
                <img
                  src={SearchAdviser}
                  style={{width: '246px', height: '145px', marginTop: '43px'}}
                />
                <h2
                  style={{
                    direction: 'rtl',
                    marginTop: '31px',
                    textAlign: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    fontFamily: 'iranSansX',
                    fontSize: '15px',
                    fontWeight: 600,
                    height: '46px',
                    color: '#1D2129',
                    letterSpacing: '0%',
                  }}
                >
                  جستجو برای
                  <br />
                  یافتن بهترین {adviserType}
                  <LoadingDots />
                </h2>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
